import { Component, inject, OnDestroy, Signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { stages } from '../../notification-general-remarks-road-marking.routes';
import { updateParcels } from '../../../../../../store/actions/application.actions';
import {
  NotificationGeneralRemarksRoadMarkingLocalisationForm
} from './forms/notification-general-remarks-road-marking-localisation.form';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ParcelsCrudComponent } from '../../../common/components/parcels/parcels-crud/parcels-crud.component';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { AlertComponent } from '../../../../../../common/alert/alert.component';
import {
  ExposedMapControlComponent
} from '../../../../../../common/exposed-map/exposed-map-control/exposed-map-control.component';
import { RoadControlsSetComponent } from '../../../common/components/road-controls-set/road-controls-set.component';

@Component({
  selector: 'app-notification-general-remarks-road-marking-localisation-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    ParcelsCrudComponent,
    CommonModule,
    ValidationErrorsComponent,
    AlertComponent,
    ExposedMapControlComponent,
    RoadControlsSetComponent
  ],
  providers: [
    NotificationGeneralRemarksRoadMarkingLocalisationForm
  ],
  templateUrl: './notification-general-remarks-road-marking-localisation-section.component.html'
})
export class NotificationGeneralRemarksRoadMarkingLocalisationSectionComponent implements OnDestroy {

  public stages: string[] = stages;

  private router: Router = inject(Router);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private store$: Store = inject(Store);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public form: NotificationGeneralRemarksRoadMarkingLocalisationForm = inject(NotificationGeneralRemarksRoadMarkingLocalisationForm);

  public submitAndGoNext(): void {
    const currentApp = this.application();
    if (this.form.valid && currentApp) {
      this.store$.dispatch(updateParcels({
        currentApp,
        payload: this.form.toWriteModel(),
        parcels: this.form.parcels.value,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../informacja-publiczna'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
